import { useTranslation } from 'react-i18next';
import { Unlink, Copy, LayoutGrid, type LucideIcon } from 'lucide-react';

// Honest capability strip — what MarkFlow actually does, no fabricated counts.
const CAPABILITIES: { icon: LucideIcon; title: string; desc: string }[] = [
  { icon: Unlink, title: 'home.stats.deadLinks', desc: 'home.stats.deadLinksDesc' },
  { icon: Copy, title: 'home.stats.duplicates', desc: 'home.stats.duplicatesDesc' },
  { icon: LayoutGrid, title: 'home.stats.filed', desc: 'home.stats.filedDesc' },
];

export function HomeStats() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-5xl px-4 sm:px-6 py-10 sm:py-14">
      <div className="grid grid-cols-1 divide-y divide-zinc-200 rounded-2xl border border-zinc-200 bg-white/60 sm:grid-cols-3 sm:divide-x sm:divide-y-0 dark:divide-white/10 dark:border-white/10 dark:bg-white/[0.03]">
        {CAPABILITIES.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.title} className="px-6 py-7 text-center">
              <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl bg-violet-50 text-violet-600 dark:bg-violet-500/10 dark:text-violet-300">
                <Icon className="h-5 w-5" strokeWidth={2} aria-hidden />
              </span>
              <div className="mt-4 font-display text-base font-semibold text-zinc-900 dark:text-zinc-50">{t(c.title)}</div>
              <div className="mt-1.5 text-sm leading-relaxed text-zinc-500 dark:text-zinc-400">{t(c.desc)}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
